var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout md-gutter md-alignment-top-center" }, [
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-icon-button md-raised md-primary md-fab",
              attrs: { to: "/" }
            },
            [_c("md-icon", [_vm._v("arrow_back")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "md-layout-item md-size-50 md-small-size-100 md-xsmall-size-100"
        },
        [
          _c(
            "form",
            {
              attrs: { novalidate: "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.validateUser.apply(null, arguments)
                }
              }
            },
            [
              _c(
                "md-card",
                [
                  _c("md-card-header", [
                    _c("div", { staticClass: "md-title" }, [
                      _vm._v("Registrieren")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card-content", [
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c("md-content", [
                            _c(
                              "p",
                              [
                                _vm._v(
                                  "\n                    Nachdem Sie das Registrierungsformular abgeschickt haben,\n                    erhalten Sie eine Email mit einem Aktivierungslink an die\n                    von Ihnen angegebene Adresse. Bitte folgen Sie diesem Link\n                    um Ihr Konto zu aktivieren und WERNER nutzen zu können.\n                    "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v("Unter dem Link\n                    "),
                                _c(
                                  "router-link",
                                  {
                                    attrs: { to: { name: "Confidentiality" } }
                                  },
                                  [_vm._v("Datenschutzerklärung")]
                                ),
                                _vm._v(
                                  " finden Sie Informationen über datenschutzrelevante\n                    Aspekte.\n                  "
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("firstname") },
                            [
                              _c("label", { attrs: { for: "first-name" } }, [
                                _vm._v("Vorname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "first-name",
                                  id: "first-name",
                                  autocomplete: "given-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.firstname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "firstname", $$v)
                                  },
                                  expression: "form.firstname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.firstname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Vorname ist notwendig")
                                  ])
                                : !_vm.$v.form.firstname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Vorname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("lastname") },
                            [
                              _c("label", { attrs: { for: "last-name" } }, [
                                _vm._v("Nachname")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "last-name",
                                  id: "last-name",
                                  autocomplete: "family-name",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.lastname,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "lastname", $$v)
                                  },
                                  expression: "form.lastname"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.lastname.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Der Nachname ist notwendig")
                                  ])
                                : !_vm.$v.form.lastname.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültiger Nachname")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-small-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("gender") },
                            [
                              _c("label", { attrs: { for: "gender" } }, [
                                _vm._v("Geschlecht")
                              ]),
                              _vm._v(" "),
                              _c(
                                "md-select",
                                {
                                  attrs: {
                                    name: "gender",
                                    "md-dense": "",
                                    disabled: _vm.sending
                                  },
                                  model: {
                                    value: _vm.form.gender,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "gender", $$v)
                                    },
                                    expression: "form.gender"
                                  }
                                },
                                [
                                  _c("md-option", { attrs: { value: "m" } }, [
                                    _vm._v("männlich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "f" } }, [
                                    _vm._v("weiblich")
                                  ]),
                                  _vm._v(" "),
                                  _c("md-option", { attrs: { value: "d" } }, [
                                    _vm._v("divers")
                                  ])
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "md-error" }, [
                                _vm._v("Das Geschlecht ist notwendig")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "md-layout-item md-small-size-100"
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "md-layout md-gutter" }, [
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("email") },
                            [
                              _c("label", { attrs: { for: "email" } }, [
                                _vm._v("Email")
                              ]),
                              _vm._v(" "),
                              _c("md-input", {
                                ref: "emailInput",
                                attrs: {
                                  type: "email",
                                  name: "email",
                                  id: "email",
                                  autocomplete: "email",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.email.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Die Mail-Adresse wird benötigt")
                                  ])
                                : !_vm.$v.form.email.email
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Ungültige Mail-Adresse")
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("password") },
                            [
                              _c("label", [_vm._v("Passwort")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "password",
                                  type: "password",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.password,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "password", $$v)
                                  },
                                  expression: "form.password"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.password.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Das Passwort wird benötigt")
                                  ])
                                : !_vm.$v.form.password.minlength
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      "Ungültiges Passwort, bitte verwenden Sie mindestens 8\n                    Zeichen."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "md-layout-item md-size-100" },
                        [
                          _c(
                            "md-field",
                            { class: _vm.getValidationClass("repassword") },
                            [
                              _c("label", [_vm._v("Passwort wiederholen")]),
                              _vm._v(" "),
                              _c("md-input", {
                                attrs: {
                                  name: "repassword",
                                  type: "password",
                                  disabled: _vm.sending
                                },
                                model: {
                                  value: _vm.form.repassword,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "repassword", $$v)
                                  },
                                  expression: "form.repassword"
                                }
                              }),
                              _vm._v(" "),
                              !_vm.$v.form.repassword.required
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v("Das Passwort wird benötigt")
                                  ])
                                : !_vm.$v.form.repassword.sameAsPassword
                                ? _c("span", { staticClass: "md-error" }, [
                                    _vm._v(
                                      "Die Passwörter stimmern nicht überein."
                                    )
                                  ])
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "md-card-actions",
                    [
                      _c(
                        "md-button",
                        {
                          staticClass: "md-primary",
                          attrs: { type: "submit" }
                        },
                        [_vm._v("Registrieren")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "md-layout-item md-size-25 md-small-size-100 md-xsmall-size-100"
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fff1e14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fff1e14","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/authentication/signup/Signup.vue
// module id = null
// module chunks = 